/*jshint esversion: 9 */
import { mapGetters } from 'vuex';
import store from '@/store/index';
export const UserHomeMixin = {
  data: () => ({
    activeContainer: [],
    positionDesktop: [ [2, -2, 1, -1, 3, -3, 4, -4],
                      [-2, -2, -1, -1, -3, -3, -4, -4],
                      [-2, -2, 6, -6, -3, -3, 5, -5],
                      [8, -8, 7, -7, -7, -7, -5, -5],
                      [-8, -8, -7, -7, -7, -7, 9, -9],
                      [0, 0, 0, 0, 0, 0, -9, -9],
                      [0, 0, 0, 0, 0, 0, -9, -9]
    ],
    positionDesktopInvites: [
                      [4, -4, 1, -1, 5, -5, 9, -9],
                      [-4, -4, -1, -1, -5, -5, -9, -9],
                      [2, -2, 6, -6, 3, -3, -9, -9],
                      [-2, -2, 0, 0, -3, -3, 8, -8],
                      [-2, -2, 0, 0, -3, -3, -8, -8],
                      [0, 0, 7, -7, -7, -7, 0, 0],
                      [0, 0, -7, -7, -7, -7, 0, 0],
    ],
    positionMedium: [ [4, -4, 5, -5],
                      [-4, -4, -5, -5],
                      [8, -8, 3, -3],
                      [-8, -8, -3, -3],
                      [2, -2, -3, -3],
                      [-2, -2, 0, 0],
                      [-2, -2, 0, 0]
    ],
    positionMobile: [ 
                      [9, -9],
                      [-9, -9],
                      // [4, -4],
                      // [-4, -4],
                      [5, -5],
                      [-5, -5],
                      [8, -8],
                      [-8, -8],
                      [2, -2],
                      [-2, -2],
                      [-2, -2],
                      [3, -3],
                      [-3, -3],
                      [-3, -3]
    ],
    containers: [
      {id: 1, widget: 'logo', width: 0, height: 0, position: false, color: 'yellow'},
      {id: 2, widget: 'loglist', width: 0, height: 0, position: false, color: 'blue'},
      {id: 3, widget: 'images', width: 0, height: 0, position: false, color: 'green'},
      {id: 4, widget: 'warnings', width: 0, height: 0, position: false, color: 'red'},
      {id: 5, widget: 'notifications', width: 0, height: 0, position: false, color: 'red'},
      {id: 6, widget: 'update', width: 0, height: 0, position: false, color: 'green'},
      {id: 7, widget: 'community', width: 0, height: 0, position: false, color: 'green'},
      {id: 8, widget: 'qrcode', width: 0, height: 0, position: false, color: 'green'},
      {id: 9, widget: 'invitations', width: 0, height: 0, position: false, color: 'red'},
      // {id: 5, widget: 'algorithmicFlow', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 6, widget: 'social', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 7, widget: 'training', width: 1, height: 1, position: false, color: 'red'},

      // {id: 8, widget: 'workbench', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 9, widget: 'taktNews', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 10, widget: 'one', width: 1, height: 1, position: false, color: 'red'},
      // {id: 11, widget: 'two', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 12, widget: 'taktPartners', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 13, widget: 'one', width: 1, height: 1, position: false, color: 'red'},
      // {id: 14, widget: 'two', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 15, widget: 'processBoards', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 16, widget: 'one', width: 1, height: 1, position: false, color: 'red'},
      // {id: 17, widget: 'two', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 18, widget: 'piktoOne', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 19, widget: 'piktoTwo', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 19, widget: 'two', width: 0.5, height: 1, position: false, color: 'blue'},
      // {id: 20, widget: 'taktConnection', width: 0.5, height: 1, position: false, color: 'blue'},

      // {id: 21, widget: 'knowledge', width: 0.5, height: 1, position: false, color: 'blue'},
      // {id: 22, widget: 'taktPower', width: 0.5, height: 1, position: false, color: 'blue'},
    ],
    min_res: 0.5,
  }),
  created() {
    let calls = [
      store.dispatch('User/requestUserProjectInvites', store.getters['Auth/getUser'].id),
    ];
    Promise.all(calls).then( () => {
      this.setPosition();
    });
  },
  computed: {
    ...mapGetters('Auth',[
      'getUser',
    ]),
    ...mapGetters('User',[
      'getProjectInvites',
    ]),
    ...mapGetters('WorkPackage',[
      'getNewIcon',
    ]),
    columns() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return this.positionMobile[0].length * this.min_res;
        case 'sm': return this.positionMedium[0].length * this.min_res;
        case 'md': return this.positionDesktop[0].length * this.min_res;
        case 'lg': return this.positionDesktop[0].length * this.min_res;
        case 'xl': return this.positionDesktop[0].length * this.min_res;
      }
    },
    matrix() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return this.positionMobile;
        case 'sm': return this.positionMedium;
        case 'md':
          if (this.getProjectInvites.length) {
            return this.positionDesktopInvites;
          }
          return this.positionDesktop;
        case 'lg':
          if (this.getProjectInvites.length) {
            return this.positionDesktopInvites;
          }
          return this.positionDesktop;
        case 'xl':
        if (this.getProjectInvites.length) {
          return this.positionDesktopInvites;
        }
        return this.positionDesktop;
      }
    }
  },
  watch: {
    '$vuetify.breakpoint.name'() {
      this.setPosition();
    },
  },
  methods: {
    setPosition() {
      this.activeContainer = [];
      let positions = this.matrix;
      this.containers.forEach(item => {
        item.position = false;
        item.width = 0;
        item.height = 0;
        //set position
        for (let i = 0; i < positions.length; i++) {
          for (let k = 0; k < positions[i].length; k++) {
            if (positions[i][k] === item.id) {
                item.position = []
                item.position.push(i)
                item.position.push(k)
            }
          }
        }
        if (item.position != false) {
          let negId = - item.id;
          let i = 1;
          //find Width
          while (negId === - item.id) {
            // console.log(item.position[0]);
            if (item.position[1] + i < positions[0].length) {
              item.width += this.min_res
              negId = positions[item.position[0]][item.position[1] + i]
              i++
            }
            else {
              item.width += this.min_res
              negId = false
            }
          }
          negId = - item.id;
          i = 1;
          //find Height
          while (negId === - item.id) {
            if(item.position[0] + i < positions.length) {
              item.height += this.min_res
              negId = positions[item.position[0] + i][item.position[1]]
              i++
            }
            else {
              item.height += this.min_res;
              negId = false;
            }
          }
          item.position[0] = item.position[0] * this.min_res
          item.position[1] = item.position[1] * this.min_res
          this.activeContainer.push(item)
        }

      });
    }



          // let array = [];
          // for (let i = 0; i < 4/this.min_res; i++) {
          //   array.push([]);
          //   for (let j = 0; j < this.columns/this.min_res; j++) {
          //     array[i].push(0);
          //   }
          // }


          //set fixed elements
          // let fixed_container = this.containers.find(cont => cont.id === 1);
          //id: 1, position: center-top
          // let fixed_row_index = 0;
          // let fixed_col_index = (this.columns/this.min_res) / 2 - 1;
          // for (let i = 0; i < fixed_container.height/this.min_res; i++) {
          //   for (let j = 0; j < fixed_container.width/this.min_res; j++) {
          //     array[fixed_row_index + i].splice(fixed_col_index + j, 1, fixed_container.id * -1);
          //   }
          // }
          // array[fixed_row_index].splice(fixed_col_index, 1, fixed_container.id);
          // fixed_container.position = [fixed_col_index * this.min_res,fixed_row_index * this.min_res];
          //end fixed elements

        //   for (var row_index = 0; row_index < array.length; row_index++) {
        //     if (this.containers.findIndex(item => item.position === false) !== -1) {
        //       let row = array[row_index];
        //       for (var col_index = 0; col_index < row.length; col_index++) {
        //         this.shuffle(this.containers);
        //         //filter
        //         let containers_filtered = this.containers.filter(container => {
        //           let boolean = true;
        //           if (col_index + container.width/this.min_res > this.columns/this.min_res) {
        //             boolean = false;
        //           }
        //           for (let i = 0; i < container.height/this.min_res; i++) {
        //             for (let j = 0; j < container.width/this.min_res; j++) {
        //               if (array[row_index + i][col_index + j] !== 0) {
        //                 boolean = false;
        //               }
        //             }
        //           }
        //           return boolean;
        //         });
        //         if (containers_filtered.findIndex(item => item.position === false) !== -1) {
        //           let container = containers_filtered.find(item => item.position === false);
        //           container.position = [col_index * this.min_res, row_index * this.min_res];
        //           for (let i = 0; i < container.height/this.min_res; i++) {
        //             for (let j = 0; j < container.width/this.min_res; j++) {
        //               array[row_index + i].splice(col_index + j, 1, container.id * -1);
        //             }
        //           }
        //           row.splice(col_index, 1, container.id);
        //         }
        //       }
        //       //if elements with no position still exist add rows
        //       if (this.containers.findIndex(item => item.position === false) !== -1) {
        //         for (let i = 0; i < (1/this.min_res)/2; i++) {
        //           array.push([]);
        //           for (let j = 0; j < this.columns/this.min_res; j++) {
        //             array[i + row_index + 2].push(0);
        //           }
        //         }
        //       }
        //     }
        //   }
        //   console.log(array);
        //   console.log(this.containers);
        // },
        // shuffle(array) {
        //   var currentIndex = array.length, temporaryValue, randomIndex;
        //
        //   // While there remain elements to shuffle...
        //   while (0 !== currentIndex) {
        //
        //     // Pick a remaining element...
        //     randomIndex = Math.floor(Math.random() * currentIndex);
        //     currentIndex -= 1;
        //
        //     // And swap it with the current element.
        //     temporaryValue = array[currentIndex];
        //     array[currentIndex] = array[randomIndex];
        //     array[randomIndex] = temporaryValue;
        //   }
        //   return array;
        // }




  }
};
